import { render, staticRenderFns } from "./NotificationPopover.vue?vue&type=template&id=748d3005&scoped=true"
import script from "./NotificationPopover.vue?vue&type=script&lang=js"
export * from "./NotificationPopover.vue?vue&type=script&lang=js"
import style0 from "./NotificationPopover.vue?vue&type=style&index=0&id=748d3005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d3005",
  null
  
)

export default component.exports